module.exports = __webpack_public_path__ + "static/20260624_S_P_Rating_Report_B-_stable-619f7ab30fdb8ea738af2359e9ce4424.pdf";